import { Dispatch } from 'redux';
import { Map, OrderedMap } from 'immutable';
import { Moment } from 'moment';

import { fetcher } from '../../lib/request';

import { Event } from '../../models/Afisha/Event';
import { Place } from '../../models/Afisha/Place';

const AFISHA_HOST = process.env.REACT_APP_AFISHA_HOST;
const AFISHA_KEY = process.env.REACT_APP_AFISHA_KEY;

export const GET_EVENTS_REQUEST = 'AFISHA_GET_EVENTS_REQUEST';
export const GET_EVENTS_RESPONSE = 'AFISHA_GET_EVENTS_RESPONSE';
export const GET_EVENTS_ERROR = 'AFISHA_GET_EVENTS_ERROR';

export const GET_EVENT_REQUEST = 'AFISHA_GET_EVENT_REQUEST';
export const GET_EVENT_RESPONSE = 'AFISHA_GET_EVENT_RESPONSE';
export const GET_EVENT_ERROR = 'AFISHA_GET_EVENT_ERROR';

export const GET_PLACE_REQUEST = 'AFISHA_GET_PLACE_REQUEST';
export const GET_PLACE_RESPONSE = 'AFISHA_GET_PLACE_RESPONSE';
export const GET_PLACE_ERROR = 'AFISHA_GET_PLACE_ERROR';

export const SET_INPUT_VALUE = 'AFISHA_SET_INPUT_VALUE';

export const ORDERS_LOG_REQUEST = 'AFISHA_ORDERS_LOG_REQUEST';
export const ORDERS_LOG_RESPONSE = 'AFISHA_ORDERS_LOG_RESPONSE';
export const ORDERS_LOG_ERROR = 'AFISHA_ORDERS_LOG_ERROR';

interface EventsResponse {
    result: Event[];
    error: any;
}

interface PlacesResponse {
    result: Place[];
    error: any;
}

interface EventResponse {
    result: Event;
    error: any;
}

interface PlaceResponse {
    result: Place;
    error: any;
}

export const getEventsAction = (
    city: number,
    q: string,
    dateFrom: Moment,
    dateTo: Moment | null = null,
    lang: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_EVENTS_REQUEST
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;

        const responseEvents = await fetcher<EventsResponse>(`${AFISHA_HOST}/api/v3/events?city_id=${city}&q=${q}&limit=10${dates}&lang=${lang}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        const responsePlaces = await fetcher<PlacesResponse>(`${AFISHA_HOST}/api/v3/places?city_id=${city}&q=${q}&limit=10${dates}&lang=${lang}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        // ???
        let compilations = Map<string, OrderedMap<number, Event | Place>>();
        [...responseEvents.result, ...responsePlaces.result].forEach((r) => {
            if (compilations.has(r.compilation)) {
                compilations = compilations.set(r.compilation, compilations.get(r.compilation).set(r.id, r));
            } else {
                compilations = compilations.set(r.compilation, OrderedMap<number, Event | Place>().set(r.id, r));
            }
        });

        dispatch({
            type: GET_EVENTS_RESPONSE,
            response: compilations,
        });
    } catch (error) {
        dispatch({
            type: GET_EVENTS_ERROR,
            error: error
        });
    }
};

export const getEventAction = (
    city: number,
    eventID: string,
    userId: string,
    dateFrom: Moment,
    dateTo: Moment | null = null,
    lang: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_EVENT_REQUEST
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;

        const response = await fetcher<EventResponse>(`${AFISHA_HOST}/api/v3/events/${eventID}?` +
            `city_id=${city}&user_id=${userId}${dates}&lang=${lang}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_EVENT_RESPONSE,
            response: response
        });

        return response.result;
    } catch (error) {
        dispatch({
            type: GET_EVENT_ERROR,
            error: error
        });

        return;
    }
};

export const getPlaceAction = (
    city: number,
    placeID: string,
    userId: string,
    dateFrom: Moment,
    dateTo: Moment | null = null,
    lang: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_PLACE_REQUEST
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;

        const response = await fetcher<PlaceResponse>(`${AFISHA_HOST}/api/v3/places/${placeID}?` +
            `city_id=${city}&user_id=${userId}${dates}&lang=${lang}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_PLACE_RESPONSE,
            response,
        });

        return response.result;

    } catch (error) {
        dispatch({
            type: GET_PLACE_ERROR,
            error: error
        });

        return;
    }
};

export const setInputValueAction = (newValue: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_INPUT_VALUE,
    newValue
});

export const ordersLogAction = (
    type: string,
    id: number,
    city: number,
    userId: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: ORDERS_LOG_REQUEST
    });

    try {
        const response = await fetcher(`${AFISHA_HOST}/api/v3/${type}/${id}/reservation?` +
            `city_id=${city}&user_id=${userId}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: ORDERS_LOG_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: ORDERS_LOG_ERROR,
            error: error
        });
    }
};



// WEBPACK FOOTER //
// ./src/actions/Afisha/events.ts